import React from 'react'

export const Footer = () => {
  return (
    <div>
        <div className="footer">
            <div className="footerContents">
                <div className="content1">
                    <div className="boxLeft">
                        <span>Company</span>
                        <p>About</p>
                        <p>Feature</p>
                        <p>Works</p>
                        <p>Carrer</p>
                    </div>
                    <div className="boxRight">
                    <span>Help</span>
                        <p>Customer support</p>
                        <p>Delivery details</p>
                        <p>Terms and condition</p>
                        <p>Privacy policy</p>
                    </div>
                </div>
                <div className="content1">
                <div className="boxLeft">
                        <span>Resources</span>
                        <p>Free eBooks</p>
                        <p>Development tutorials</p>
                        <p>How to blog  </p>
                        <p>Youtue playlist</p>
                    </div>
                    <div className="boxRight">
                    <span>Links</span>
                        <p>Free eBooks</p>
                        <p>Developmemt tutorials</p>
                        <p>How to blog</p>
                        <p>Youtube playlist</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
